import React from 'react';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { Testimonials, type Testimonial } from './components/Testimonials';
import { PainGrid } from './components/PainGrid';
import { BigIdea } from './components/BigIdea';
import { ProductReveal } from './components/ProductReveal';
import { Tomes } from './components/Tomes';
import { Bonuses } from './components/Bonuses';
import { Urgency } from './components/Urgency';
import { Pricing } from './components/Pricing';
import { Transformation } from './components/Transformation';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { CostOfInaction } from './components/CostOfInaction';
import { Close } from './components/Close';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
const firstBatch: Testimonial[] = [{
  quote: 'Venía cobrando 4.000 pesos por «ayudar» en bodas. Usé los guiones del Tomo 2 con la primera consulta que me entró y cerré en 32.000. Mismo trabajo, otra conversación.',
  author: 'Valeria Ríos',
  role: 'Wedding Planner · CDMX, México',
  photo: 'https://cdn.magicpatterns.com/patterns/generated-images/5c642323-af22-4fc6-acab-7143fc5d5069.jpg'
}, {
  quote: 'Una pareja me había dejado en visto tres semanas. Mandé el segundo mensaje del Protocolo Anti-Ghosting y me contestaron en dos horas. Firmaron el viernes siguiente.',
  author: 'Camila Restrepo',
  role: 'Wedding Planner · Medellín, Colombia',
  photo: 'https://cdn.magicpatterns.com/patterns/generated-images/e4af9b53-e01a-4856-9ac3-01beefdbf60a.jpg'
}, {
  quote: 'Antes era «la que ayuda con las bodas». Hoy las novias me escriben por mi nombre y me preguntan si tengo fecha disponible. Eso cambió con el Tomo 1, no con más seguidores.',
  author: 'Antonella Vega',
  role: 'Wedding Planner · Santiago, Chile',
  photo: 'https://cdn.magicpatterns.com/patterns/generated-images/45a17af3-645e-4650-9154-6d8196a54641.jpg'
}];
const secondBatch: Testimonial[] = [{
  quote: 'El Embudo de WhatsApp Gold me sacó del pánico de contestar. Ya no manda el precio de golpe: pregunto, detecto presupuesto y agendo llamada. Cerré 3 de las últimas 5 consultas.',
  author: 'Mariana Ferrer',
  role: 'Wedding Planner · Buenos Aires, Argentina',
  photo: 'https://cdn.magicpatterns.com/patterns/generated-images/d31d3084-4881-4aa2-bce4-e9c77e7a7c71.jpg'
}, {
  quote: 'Con el Pack Anti-Regateo dejé de ceder. Me pidieron descuento, copié la respuesta tal cual y la novia contestó «entiendo, avancemos». Nunca lo había logrado sin sentir culpa.',
  author: 'Daniela Quispe',
  role: 'Wedding Planner · Lima, Perú',
  photo: 'https://cdn.magicpatterns.com/patterns/generated-images/9665b3ab-786b-4aa7-9019-1f69f2cdbf61.jpg'
}, {
  quote: 'Pagaba cuota al portal y solo me llegaban parejas preguntando precio. Con el Tomo 6 llevo los leads directo a mi WhatsApp y este año no renové la suscripción.',
  author: 'Lucía Sandoval',
  role: 'Wedding Planner · Guadalajara, México',
  photo: 'https://cdn.magicpatterns.com/patterns/generated-images/955f3e21-32a5-4bb0-9499-2b016216936f.jpg'
}];
export function App() {
  return <div className="min-h-screen w-full bg-ivory text-ink font-sans selection:bg-gold selection:text-ink" data-id="element-0" data-mp="13ey3xxyqdeb0">
      <MetaPixel data-id="element-1" data-mp="1r529wbze5q56" />
      <main data-id="element-2" data-mp="1r2fwvwtqeifk">
        <Hero data-id="element-3" data-mp="1w33nwihymz9s" />
        <SocialProofBar data-id="element-4" data-mp="1w3lv2a65uxwh" />
        <Testimonials testimonials={firstBatch} background="white" data-id="element-5" data-mp="1w20wm9gq6utc" />
        <PainGrid data-id="element-6" data-mp="1i443xo5e78jy" />
        <BigIdea data-id="element-7" data-mp="1i2j9dyj2vpm3" />
        <ProductReveal data-id="element-8" data-mp="1i31elknpxe65" />
        <Tomes data-id="element-9" data-mp="1i5x7gukplcnq" />
        <Bonuses data-id="element-10" data-mp="1m4wag9mvqzcj" />
        <Urgency data-id="element-11" data-mp="1m4ej9rf2rbbh" />
        <Pricing data-id="element-12" data-mp="1m3uym2y1i8tr" />
        <Transformation data-id="element-13" data-mp="1m3cuyl91ssbt" />
        <Testimonials testimonials={secondBatch} title="Más planners que dejaron de improvisar" background="ivory" data-id="element-14" data-mp="6ofdgmsxjree" />
        <Guarantee data-id="element-15" data-mp="aqshn6s13h92" />
        <Faq data-id="element-16" data-mp="arbyek5xzzli" />
        <CostOfInaction data-id="element-17" data-mp="ano7ztvsntb0" />
        <Close data-id="element-18" data-mp="qxnl5jfbeau0" />
      </main>
      <Footer data-id="element-19" data-mp="qxxdhdnu0u2v" />
    </div>;
}